import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from '../c005-bookingform-common';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
require('parsley');
import 'html2canvas';
import 'MagnificPopup';

export class enrichCobrandCards {
    private cobrandFormPage: any = $('#co-brand_partners');

    initTextInputs(): any {
        let _self = this;
        $('.click-text').click(function () {
            $(this).addClass('hideclass');
            if ($(this).closest('.co-brand').find('.card-details').hasClass("hideclass")) {
                $(this).closest('.co-brand').find('.card-details').removeClass('hideclass');
            }
            if ($(this).closest('.co-brand').find('.card2-details').hasClass("hideclass")) {
                $(this).closest('.co-brand').find('.card2-details').removeClass('hideclass');
            }
            $(this).closest('.co-brand').find('.card-details').addClass('showclass');
            $(this).closest('.co-brand').find('.card2-details').addClass('showclass');
        });
    }

}
$(document).ready(function () {
    let _self = this;
    // let requestData = {
    //     cobrandCardType:'null',
    //     cobrnadExpiryDate:'null'
    // }
    let cobrandCardType: null;
    let cobrnadExpiryDate: null;
    let attributes: any = [];
    
    let getCardType = function () {
        const cobrandCards = document.querySelectorAll('.co-brand');
        if (cobrandCards.length > 0) {
        $(cobrandCards).each(function (itemCount: any, categorytest: any) {
            cobrandCardType = $(categorytest).children().find('#co-brand--card-type').val();
            cobrnadExpiryDate = $(categorytest).children().find('#co-brand--expiry-date').val();
            attributes.push({
                'key': 'Enrich-Cobrand-Card-Type',
                'value': cobrandCardType
            });
            attributes.push({
                'key': 'Enrich-Cobrand-Expiry-Date',
                'value': cobrnadExpiryDate
            });
        })
    } 
    }
    getCardType();
    adobeDataLayer.push('pageLoad', {
        'pageName': 'mas:my:en:enrich-portal:home:cobrand',
        'pageType': 'Enrich Cobrand Page',
        'attributes': attributes,
    });
});
declare const window: any;
let scope: Element = document.querySelector('#cobrand--cards_members');
if (scope) {
    try {
        let cobrandCards = new enrichCobrandCards();
        var adobeDataLayer = new adobeDataLayerWrapper();
        let isAdobePageLoaded = adobeDataLayer.getCookie('cobrandPageLoaded');
        if (isAdobePageLoaded !== 'true') {
            adobeDataLayer.setCookie('cobrandPageLoaded', true, 30);
            window.adobeDataLayer.push('pageLoaded', {
                'pageName': 'mas:my:en:enrich-portal:home:cobrand',
                'pageType': 'Enrich Cobrand Page',
            });
        }
        cobrandCards.initTextInputs();
    } catch (e) { console.error(e); }
}
